import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

// Components
import Avatar from '../../Avatar'
import Icon from '../../icon/Icon'

// Styles
import { mqFrom } from '../../../styles/mediaQueries'

// Utils
import { getContactType } from '../../../utils/onboardingHelper'

// Types
import { OnboardingContactType } from '../../../common/models/OnboardingTemplates'
import { ICompanyMember } from '../../../common/models/Company'
import { IconType } from '../../icon/IconType'

interface IContactAvatarProps {
  className?: string
  contactType?: OnboardingContactType
  member?: ICompanyMember
  iconSize?: number
  iconType?: IconType
}

export const ContactAvatar: React.FC<IContactAvatarProps> = ({
  className,
  iconSize,
  contactType,
  member,
  iconType,
}) => {
  const theme = useContext(ThemeContext)

  return (
    <AvatarContainer className={className}>
      {member ? (
        <Avatar user={member} />
      ) : (
        <Icon
          type={
            iconType ||
            (contactType
              ? (getContactType(contactType).icon as IconType)
              : 'User')
          }
          color={theme.colors.primary}
          size={iconSize || 20}
        />
      )}
    </AvatarContainer>
  )
}

const AvatarContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${({ theme }) => theme.colors.textLightest};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${mqFrom.M`
    width: 36px;
    height: 36px;
    margin-right: 12px;
  `}
`
